import { upperFirst } from "lodash";
import { useState } from "react";
import InfiniteLoader from "../components/InfiniteLoader";
import { Container, Tab, Tabs } from "@mui/material";
import { tabStyle } from "utils/styles";
import { ContactComp, TabPanel } from "utils/unitComponent";

// ----------------------------------------------------------------------

export default function Contact() {
  const nav = [
    { label: "FAQ", value: "faq" },
    { label: "공지사항", value: "notice" },
    // { label: '1:1 문의하기', value: 'inquiry' },
  ];

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Container
      sx={{
        py: 20,
        flexGrow: 1,
        display: "flex",
      }}
    >
      <Tabs
        orientation="vertical"
        value={value}
        onChange={handleChange}
        sx={{ ...tabStyle }}
      >
        {nav.map((item, i) => (
          <Tab key={i} id={`${item.value}`} label={item.label} />
        ))}
      </Tabs>
      {nav.map((n, i) => {
        const url = [
          "https://api.queenssmile.co.kr/api/v1/faqs",
          "https://api.queenssmile.co.kr/api/v1/notices",
        ][value];
        console.log("url", url, value);
        return (
          <TabPanel active={value === i}>
            <InfiniteLoader key={value} url={url} dataKey="faqResBodies">
              {(item) => ContactComp[upperFirst(n.value)](item)}
            </InfiniteLoader>
          </TabPanel>
        );
      })}
    </Container>
  );
}
